import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Configure worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFPreview = ({ file, width = 300, onClick }) => {
    const [numPages, setNumPages] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <div
            style={{
                border: '1px solid #ddd',
                cursor: onClick ? 'pointer' : 'default',
                display: 'inline-block',
                maxWidth: '100%',
                overflow: 'hidden',
                position: 'relative',
                background: '#f4f4f4'
            }}
            onClick={onClick}
        >
            <Document
                file={file}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<div style={{ padding: '20px', textAlign: 'center' }}>Loading PDF...</div>}
                error={<div style={{ padding: '20px', color: 'red' }}>Failed to load PDF.</div>}
            >
                <Page
                    pageNumber={1}
                    width={width}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                />
            </Document>
            {numPages && (
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    background: 'rgba(0,0,0,0.7)',
                    color: 'white',
                    padding: '2px 5px',
                    fontSize: '0.7rem'
                }}>
                    1 / {numPages}
                </div>
            )}
        </div>
    );
};

export default PDFPreview;
